export enum EnvName
{
  LOCAL = 'local',
  DEV = 'development',
  PROD  = 'production',
}
